<template>
  <v-dialog
    v-if="value"
    :value="value"
    @input="input => $emit('input', input)"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <div style="min-height: 100%; overflow-y: hidden; background-color: #f1f3f4;">
      <div class="d-flex flex-column" style="border-right: 1px solid #e2e2e2">
        <header class="pa-4 white d-flex align-center" style="font-size: 1.3em; height: 64px;">
          <v-btn icon @click="$emit('input', false)" class="mr-2">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <span>Editar link para {{(project || {}).name}}</span>
          <v-spacer></v-spacer>
          <v-btn class="mr-3" text color="red" v-if="(project || {}).role === 'Administrador'" @click="modalDestroy = true">Apagar link</v-btn>
          <v-btn color="secondary" depressed :disabled="!form.url" style="width: 150px;" @click="save()" :loading="loading">Salvar</v-btn>
        </header>
        <div class="d-flex">
          <div class="pa-4 flex-grow-1">
            <div class="d-flex mt-1 justify-center">
              <div class="font-weight-bold grey--text text--darken-1 d-flex align-center" style="width: 100%; max-width: 800px">
                <v-icon class="mr-1">mdi-link-variant</v-icon>
                <span>Configure seu link</span>
                <a class="ml-1 green--text" v-if="!isActivePlan" @click="$router.push('/plano?show=true')">- Para habilitar todos os campos, clique aqui contrate um de nossos planos :)</a>
              </div>
            </div>
            <v-card flat class="mt-5 pa-4 d-flex justify-center">
              <div style="max-width: 800px">
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      label="Atribua um nome ao seu link *"
                      autofocus
                      v-model="form.name"
                      outlined
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-select
                      label="Tipo de link"
                      v-model="form.mode"
                      item-text="text"
                      item-value="value"
                      :items="[{ value: 'direct', text: 'Redirecionamento ' }, { value: 'preview', text: 'Mini página' }]"
                      outlined
                      hide-details
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-select
                      :items="['Link', 'Telegram', 'Telefone', 'Email', 'iFood', 'Messenger', 'WhatsApp']"
                      v-model="type"
                      label="URL de destino"
                      outlined
                      hide-details
                    >
                      <template v-slot:item="{ item }">
                        <div class="d-flex align-center mr-3">
                          <img v-if="item === 'Link'" src="/img/link.svg" style="width: 24px;" alt="Link">
                          <img v-if="item === 'Telegram'" src="/img/telegram.svg" style="width: 20px;" alt="Telegram">
                          <img v-if="item === 'WhatsApp'" src="/img/wpp.svg" style="width: 22px;" alt="WhatsApp">
                          <img v-if="item === 'Telefone'" src="/img/phone.svg" style="width: 22px;" alt="Telefone">
                          <img v-if="item === 'Messenger'" src="/img/messenger.svg" style="width: 20px;" alt="Messenger">
                          <img v-if="item === 'Email'" src="/img/email.svg" style="width: 20px;" alt="Email">
                          <img v-if="item === 'iFood'" src="/img/ifood.svg" style="width: 20px;" alt="iFood">
                        </div>
                        <div class="pt-1 pb-1 d-flex flex-column">
                          <span class="caption font-weight-medium">{{item}}</span>
                        </div>
                      </template>
                      <template v-slot:selection="{ item }">
                        <div class="mr-2 d-flex align-center">
                          <img v-if="item === 'Link'" src="/img/link.svg" style="width: 24px;" alt="Link">
                          <img v-if="item === 'Telegram'" src="/img/telegram.svg" style="width: 20px;" alt="Telegram">
                          <img v-if="item === 'WhatsApp'" src="/img/wpp.svg" style="width: 22px;" alt="WhatsApp">
                          <img v-if="item === 'Telefone'" src="/img/phone.svg" style="width: 22px;" alt="Telefone">
                          <img v-if="item === 'Messenger'" src="/img/messenger.svg" style="width: 20px;" alt="Messenger">
                          <img v-if="item === 'Email'" src="/img/email.svg" style="width: 20px;" alt="Email">
                          <img v-if="item === 'iFood'" src="/img/ifood.svg" style="width: 20px;" alt="iFood">
                        </div>
                        <span>{{ item }}</span>
                      </template>
                    </v-select>
                  </v-col>
                  <template v-if="type === 'Telegram'">
                    <v-col cols="12" md="6">
                      <v-text-field
                        label="Insira seu username"
                        v-model="telegram"
                        outlined
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </template>
                  <template v-else-if="type === 'Messenger'">
                    <v-col cols="12" md="6">
                      <v-text-field
                        label="Insira seu username"
                        v-model="messenger"
                        outlined
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </template>
                  <template v-else-if="type === 'Telefone'">
                    <v-col cols="12" md="6">
                      <v-text-field
                        label="Insira seu telefone (com DDI e DDD)"
                        v-model="phone"
                        outlined
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </template>
                  <template v-else-if="type === 'Email'">
                    <v-col cols="12" md="6">
                      <v-text-field
                        label="Insira o seu email para recebimento"
                        hide-details
                        v-model="mailto.email"
                        outlined
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-text-field
                        label="Insira o assunto padrão"
                        v-model="mailto.subject"
                        outlined
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-textarea
                        :rows="3"
                        label="Insira o conteúdo padrão"
                        v-model="mailto.body"
                        outlined
                        hide-details
                      ></v-textarea>
                    </v-col>
                  </template>
                  <template v-else-if="type === 'WhatsApp'">
                    <v-col cols="12" md="6">
                      <v-text-field
                        label="Insira seu celular (com DDI e DDD)"
                        hide-details
                        v-model="whatsapp"
                        outlined
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-text-field
                        label="Insira seu texto personalizado para o WhatsApp"
                        v-model="msg"
                        outlined
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </template>
                  <v-col cols="12" md="6" v-else-if="type === 'iFood'">
                    <v-text-field
                      label="Insira a URL do restaurante"
                      v-model="form.url"
                      outlined
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" v-else>
                    <v-text-field
                      label="Insira a URL"
                      v-model="form.url"
                      outlined
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
                <template v-if="form.mode === 'preview'">
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field
                        label="Insira o nome do seu negócio*"
                        v-model="form.title"
                        outlined
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="12">
                      <v-text-field
                        label="Insira uma descrição do seu negócio (até 400 caracteres)"
                        v-model="form.description"
                        outlined
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </template>
                <v-row>
                  <v-col cols="12" md="6">
                    <zp-pixel-select
                      v-model="form.pixels"
                      label="Pixels"
                      :multiple="true"
                    ></zp-pixel-select>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      label="Evento"
                      v-model="form.pixel_event"
                      outlined
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-select
                      label="Selecione o domínio"
                      outlined
                      v-model="form.domain_id"
                      :items="domains"
                      item-text="name"
                      item-value="id"
                      hide-details
                      placeholder="zprs.in"
                      clearable
                      no-data-text="Nenhum domínio cadastrado"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      :loading="loadingshortened"
                      style="width: 100%; max-width: 300px;"
                      label="Customize a URL"
                      v-model="form.shortened"
                      :disabled="!form.domain_id && !isActivePlan"
                      outlined
                      persistent-hint
                      :color="!loadingshortened ? (available ? 'green' : 'red') : 'blue'"
                      :append-icon="!loadingshortened ? (available ? 'mdi-check-circle' : 'mdi-cancel') : 'mdi-cloud-search'"
                      :hint="!loadingshortened ? (available ? 'Link disponível :)' : 'Link indisponível :(') : 'Verificando disponibilidade...'"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
              </div>
            </v-card>
            <div class="mt-5 mb-10">
              <div class="d-flex justify-center">
                <div class="font-weight-bold grey--text text--darken-1 d-flex align-center" style="width: 100%; max-width: 800px">
                  <v-icon class="mr-1">mdi-cog</v-icon>
                  <span>Opções avançadas</span>
                  <a class="ml-1 green--text" v-if="!isActivePlan" @click="$router.push('/plano?show=true')">- Para habilitar todos os campos, clique aqui contrate um de nossos planos :)</a>
                </div>
              </div>
              <v-card class="pa-6 mt-5" flat>
                <div class="d-flex justify-center">
                  <div style="width: 100%; max-width: 800px">
                    <v-row>
                      <v-col md="6">
                        <zp-link-favicon v-model="form.favicon"></zp-link-favicon>
                      </v-col>
                      <v-col md="6">
                        <zp-link-thumbnail :form="form"></zp-link-thumbnail>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </v-card>
            </div>
          </div>
          <div class="pa-4 pl-0">
            <div class="d-flex mt-1 justify-center">
              <div class="font-weight-bold grey--text text--darken-1 d-flex align-center" style="width: 100%; max-width: 800px">
                <v-icon class="mr-1">mdi-cellphone</v-icon>
                <span>Seu link aparecerá assim:</span>
              </div>
            </div>

            <zp-mobile-device class="mt-5" v-model="form"></zp-mobile-device>
          </div>
        </div>
      </div>

      <zp-alert-modal v-model="modalDestroy" icon="/img/alert/alert.svg" @ok="destroy()" cancel>
        <div class="d-flex flex-column">
          <h3>Pense bem!</h3>
          <span class="mt-2">Tem certeza que deseja apagar o link? Esta ação não pode ser desfeita.</span>
        </div>
      </zp-alert-modal>

      <zp-alert-modal v-model="modalPermission" icon="/img/alert/access-denied.svg" @ok="modalPermission = false">
        <div class="d-flex flex-column">
          <span>Você não possui permissão para realizar esta ação.</span>
        </div>
      </zp-alert-modal>
    </div>
  </v-dialog>
</template>

<script>
import qs from 'qs'
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'
import LinkService from '@/services/LinkService'
import ZpMobileDevice from './MobileDevice.vue'
import ZpPixelSelect from '@/components/Pixel/Select'
import ZpAlertModal from '@/components/AlertModal.vue'
import ZpLinkFavicon from '@/components/Link/Favicon.vue'
import ZpLinkThumbnail from '@/components/Link/Thumbnail.vue'

export default {
  props: ['value'],
  components: {
    ZpMobileDevice,
    ZpPixelSelect,
    ZpAlertModal,
    ZpLinkFavicon,
    ZpLinkThumbnail
  },
  data () {
    return {
      loading: false,
      type: 'WhatsApp',
      msg: '',
      whatsapp: '',
      telegram: '',
      messenger: '',
      phone: '',
      mailto: {
        email: '',
        subject: '',
        body: ''
      },
      available: false,
      loadingshortened: false,
      modalDestroy: false,
      modalPermission: false,
      form: {
        name: '',
        shortened: '',
        domain_id: null,
        mode: 'direct',
        url: '',
        pixels: [],
        pixel_event: 'PageView',
        favicon: null,
        title: '',
        description: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      project: 'projects/getSelected',
      domains: 'domains/getVerified'
    }),
    ...mapState({
      user: state => state.auth.user
    }),
    isActivePlan () {
      return moment(this.user.active_plan_at || 0).valueOf() > Date.now() || this.user.id !== this.project.user_id
    },
    textFieldShortened () {
      const textFieldShortened = {
        color: 'blue',
        appendIcon: 'mdi-cloud-search',
        hint: 'Verificando disponibilidade...'
      }

      if (this.loadingshortened) {
        textFieldShortened.color = 'blue',
        textFieldShortened.appendIcon = 'mdi-cloud-search',
        textFieldShortened.hint = 'Verificando disponibilidade...'
      } else if (this.available) {
        textFieldShortened.color = 'green',
        textFieldShortened.appendIcon = 'mdi-check-circle',
        textFieldShortened.hint = 'Link disponível :)'
      } else if (this.value && this.value.shortened === this.form.shortened) {
        textFieldShortened.color = 'green',
        textFieldShortened.appendIcon = 'mdi-check-circle',
        textFieldShortened.hint = 'Este é o link que está em uso :)'
      } else {
        textFieldShortened.color = 'red',
        textFieldShortened.appendIcon = 'mdi-cancel',
        textFieldShortened.hint = 'Link indisponível :('
      }

      return textFieldShortened
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function (value, _value) {
        if (value && !_value) {
          this.setForm(value)
        }
      }
    },
    'form.shortened': function (shortened) {
      if (!shortened) {
        this.available = false
      }

      if (shortened === this.value.shortened) {
        return false
      }

      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => this.searchAvailable(), 500)
    },
    'form.description': function (description) {
      if (description.length > 400) {
        this.form.description = description.substring(0, 400)
      }
    },
    'form.domain_id': function () {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => this.searchAvailable(), 500)
    },
    whatsapp: function () {
      setImmediate(() => this.refreshUrl())
    },
    telegram: function () {
      setImmediate(() => this.refreshUrl())
    },
    messenger: function () {
      setImmediate(() => this.refreshUrl())
    },
    phone: function () {
      setImmediate(() => this.refreshUrl())
    },
    mailto: {
      deep: true,
      handler: function () {
        setImmediate(() => this.refreshUrl())
      }
    },
    msg: function () {
      setImmediate(() => this.refreshUrl())
    }
  },
  methods: {
    setForm (link = this.value) {
      this.form = JSON.parse(JSON.stringify(link))

      if (link.url.indexOf('https://wa.me') === 0) {
        this.type = 'WhatsApp'
        const url = link.url.replace('https://wa.me/', '')
        this.whatsapp = url.split('?')[0].replace(/[^0-9]/g, '')
        this.msg = decodeURIComponent(qs.parse(url.split('?')[1]).text || '')
      } else if (link.url.indexOf('https://t.me') === 0) {
        this.type = 'Telegram'
        this.telegram = link.url.replace('https://t.me/', '')
      } else if (link.url.indexOf('https://m.me') === 0) {
        this.type = 'Messenger'
        this.messenger = link.url.replace('https://m.me/', '')
      } else if (link.url.indexOf('tel:') === 0) {
        this.type = 'Telefone'
        this.phone = link.url.replace('tel:', '')
      } else if (link.url.indexOf('mailto:') === 0) {
        this.type = 'Email'
        const url = link.url.replace('mailto:', '')
        this.mailto = {
          email: url.split('?')[0],
          subject: qs.parse(url.split('?')[1]).subject || '',
          body: qs.parse(url.split('?')[1]).body || ''
        }
      } else if (link.url.indexOf('ifood.com.br') > -1) {
        this.type = 'iFood'
      } else {
        this.type = 'Link'
        this.msg = ''
        this.whatsapp = ''
      }
    },
    refreshUrl () {
      if (this.type === 'WhatsApp') {
        this.form.url = `https://wa.me/${this.whatsapp.replace(/[^\d]/g, '')}?text=${encodeURIComponent(this.msg)}`
      }

      if (this.type === 'Telegram') {
        this.form.url = `https://t.me/${this.telegram}`
      }

      if (this.type === 'Messenger') {
        this.form.url = `https://m.me/${this.messenger}`
      }

      if (this.type === 'Email') {
        this.form.url = `mailto:${this.mailto.email}?subject=${this.mailto.subject}&body=${this.mailto.body}`
      }

      if (this.type === 'Telefone') {
        this.form.url = `tel:${this.phone.replace(/[^\d]/g, '')}`
      }
    },
    async searchAvailable () {
      this.available = false
      this.loadingshortened = true
      this.available = await LinkService.isAvailable(this.form)
      this.loadingshortened = false
    },
    async save () {
      if (!this.isActivePlan && this.form.pixels.length > 1) {
        return alert('Por favor, contrate um de nossos planos para atribuir mais de 1 pixel :)')
      }

      this.loading = true

      try {
        this.form.domain_id = this.form.domain_id || null

        const data = await this.$store.dispatch('links/update', {
          project_id: this.project.id,
          id: this.form.id,
          data: {
            ...this.form,
            pixels: this.form.pixels.map(item => item.id)
          }
        })

        this.setForm(data)
      } catch (e) {
        this.modalPermission = e.message === 'Você não possui permissão para realizar esta ação.'
        
        if (!this.modalPermission) {
          alert(e.message)
        }
      }

      this.loading = false
    },
    async destroy () {
      try {
        await this.$store.dispatch('links/destroy', {
          project_id: this.project.id,
          id: this.form.id
        })

        this.$emit('input', false)
      } catch (e) {
        this.modalPermission = e.message === 'Você não possui permissão para realizar esta ação.'

        console.log(e.message)

        if (!this.modalPermission) {
          alert(e.message)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>